import Vue from 'vue';
import Router from 'vue-router';

/* layout */
import Layout from '@/views/layout/Layout';
import { getUserInfo } from '@/utils/auth';

Vue.use(Router);

/**
* icon : the icon show in the sidebar
* hidden : if `hidden:true` will not show in the sidebar
* redirect : if `redirect:noredirect` will not redirct in the levelbar
* noDropdown : if `noDropdown:true` will not has submenu in the sidebar
* meta : `{ role: ['admin'], desc: '' }`  will control the page role
* */
export const constantRouterMap = [
  {
    path: '/',
    component: Layout,
    redirect: '/dashboard',
    name: 'Home',
    meta: {
      desc: 'Home'
    },
    hidden: true,
    children: [{
      path: 'dashboard',
      component: require('@/views/dashboard/index').default,
      meta: {
        desc: 'Dashboard'
      }
    }]
  },
  {
    path: '/login',
    component: require('@/views/login/index').default,
    name: 'Login',
    hidden: true
  },
  {
    path: '/system',
    component: Layout,
    icon: 'quanxian',
    redirect: '/system/user',
    meta: {
      actionId: 'account',
      desc: '系统管理'
    },
    children: [
      {
        path: 'city',
        name: 'systemCity',
        component: require('@/views/system/city').default,
        meta: {
          actionId: 'account_rights',
          breadcrumb: [],
          desc: '城市管理'
        }
      },
      {
        path: 'role',
        name: 'systemRole',
        component: require('@/views/system/role').default,
        meta: {
          actionId: 'account_rights',
          breadcrumb: [],
          desc: '角色管理'
        }
      },
      {
        path: 'user',
        name: 'systemUser',
        component: require('@/views/system/user').default,
        meta: {
          actionId: 'account_users',
          breadcrumb: [],
          desc: '账号管理'
        }
      },
    ]
  },
  {
    path: '/data',
    component: Layout,
    icon: 'EXCEL',
    meta: {
      actionId: 'datacenter',
      desc: '数据中心'
    },
    children: [
      {
        path: 'bikeDataReport',
        name: 'bikeDataReport',
        component: require('@/views/dataCenter/bikeDataReport').default,
        meta: {
          actionId: 'datacenter_bikeReport', // 'datacenter_bikeReport',
          breadcrumb: [],
          desc: '单车数据报告'
        }
      },
      {
        path: 'operation',
        name: 'operation',
        component: require('@/views/dataCenter/operation').default,
        meta: {
          actionId: 'datacenter_bike',
          breadcrumb: [],
          desc: '单车运营数据'
        }
      },
      {
        path: 'evOperation',
        name: 'evOperation',
        component: require('@/views/dataCenter/evOperation').default,
        meta: {
          actionId: 'datacenter_bicycle',
          breadcrumb: [],
          desc: '助力车运营数据'
        }
      }
    ]
  },
  {
    path: '/order',
    component: Layout,
    icon: 'table',
    meta: {
      actionId: 'ordercenter',
      desc: '订单中心'
    },
    children: [
      {
        path: 'index',
        name: 'order',
        component: require('@/views/order/index').default,
        meta: {
          actionId: 'ordercenter_bike',
          breadcrumb: [],
          desc: '单车订单数据'
        }
      },
      {
        path: 'scenic',
        name: 'scenicOrder',
        component: require('@/views/order/scenicOrder').default,
        meta: {
          actionId: 'ordercenter_scenic',
          breadcrumb: [],
          desc: '景区订单数据'
        }
      },
      {
        path: 'evOrder',
        name: 'evOrder',
        component: require('@/views/order/evOrder').default,
        meta: {
          actionId: 'ordercenter_bicycle',
          breadcrumb: [],
          desc: '助力车订单数据'
        }
      },
      {
        path: 'hitch',
        name: 'hitch',
        component: require('@/views/order/hitch').default,
        meta: {
          actionId: 'ordercenter_hitch',
          breadcrumb: [],
          desc: '顺风车订单数据'
        }
      },
      {
        path: 'hitch/detail',
        name: 'hitchDetail',
        hidden: true,
        component: require('@/views/order/hitch/detail').default,
        meta: {
          actionId: 'ordercenter_hitch',
          breadcrumb: [],
          desc: '顺风车订单数据 - 详情'
        }
      },
    ]
  },
  {
    path: '/info',
    component: Layout,
    icon: 'info',
    redirect: '/info/hitch-vehicles',
    meta: {
      actionId: 'ordercenter',
      desc: '信息查询'
    },
    children: [
      {
        path: 'hitch-vehicles',
        name: 'hitchInfoVehicles',
        component: require('@/views/info/hitch/vehicles').default,
        meta: {
          actionId: 'ordercenter_hitch',
          breadcrumb: [],
          desc: '顺风车车辆数据查询',
          keepAlive: true,
        }
      },
      {
        path: 'hitch-vehicle',
        name: 'hitchInfoVehicle',
        hidden: true,
        component: require('@/views/info/hitch/vehicle').default,
        meta: {
          actionId: 'ordercenter_hitch',
          breadcrumb: [],
          desc: '顺风车车辆信息 - 详情'
        }
      },
    ],
  },
  {
    path: '/map',
    component: Layout,
    icon: 'zonghe',
    meta: {
      actionId: 'hot',
      desc: '热力图'
    },
    children: [
      {
        path: 'bike',
        name: 'bikeHotMap',
        component: require('@/views/heatmap/index').default,
        meta: {
          actionId: 'hot_bike',
          breadcrumb: [],
          desc: '单车热力图'
        }
      },
      {
        path: 'bicycle',
        name: 'bicycleHotMap',
        component: require('@/views/heatmap/evMap').default,
        meta: {
          actionId: 'hot_bicycle',
          breadcrumb: [],
          desc: '助力车热力图'
        }
      }
    ]
  },
  {
    path: '/monitor',
    component: Layout,
    icon: 'tubiao',
    meta: {
      actionId: 'map',
      desc: '监控地图'
    },
    children: [
      {
        path: 'bike',
        name: 'bikeMonitorMap',
        component: require('@/views/monitorMap/index').default,
        meta: {
          actionId: 'map_bike',
          breadcrumb: [],
          desc: '单车监控地图'
        }
      },
      {
        path: 'bicycle',
        name: 'bicycleMonitorMap',
        component: require('@/views/monitorMap/evMap').default,
        meta: {
          actionId: 'map_bicycle',
          breadcrumb: [],
          desc: '助力车监控地图'
        }
      }
    ]
  },
];

const router = new Router({
  scrollBehavior: () => ({ y: 0 }),
  routes: constantRouterMap
});

router.beforeEach(async (to, from, next) => {
  window.cancelTokenList.forEach(x => x.cancel());
  window.cancelTokenList = [];
  const user = getUserInfo();
  if ((user.token && user.user) || to.name === 'Login') {
    next();
  } else {
    next('/login');
  }
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js